import "../project.scss";
import "../projectResponse.scss";
import "./singleMatrix.scss";
import React, {useEffect, useState} from "react";
import { Helm } from "../../../components";
import { Link, useParams } from "react-router-dom";
import lock_open_icon from "../../../assets/icons/lock_open_icon.png";
import lock_closed_icon from "../../../assets/icons/lock_closed_icon.png";
import lock_open_green_icon from "../../../assets/icons/lock_open_green_icon.png";
import AuthPopup from './Popups/AuthPopup';
import AddProjectPopup from "./Popups/AddProjectPopup";
import EditProjectPopup from "./Popups/EditProjectPopup";
import DeleteProjectPopup from "./Popups/DeleteProjectPopup";
const SingleMatrix = ({ lang, donors, matrix, fetchMatrix }) => {
    let [donor, setDonor] = useState({});
    let tpc1 = 0, gla1 = 0, gc1 = 0;
    let tpc2 = 0, gla2 = 0, gc2 = 0;

    const expiret = Number(localStorage.getItem('expiret_at'));

    const token = localStorage.getItem('dToken');
    const page = localStorage.getItem('page');

    if (Math.floor(Date.now() / 1000) > expiret) {
        localStorage.removeItem("dToken");
        localStorage.removeItem("page");
        localStorage.removeItem("expiret_at");
    }
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const handlePopupToggle = () => setIsPopupOpen(!isPopupOpen);

    const { id } = useParams();
    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            setTableFull(false)
        }
    });
    // Faqat shu donor loyihalarini filter qilamiz
    const donorProjects = matrix.isFetched
        ? matrix.data.filter(m => m.donor_id == id)
        : [];
    useEffect(() => {
        setDonor(Array.isArray(donors.data) ? donors.data.filter(d => d.id == id)[0] : {});
    }, [id, donors]);
    const [tableFull, setTableFull] = useState(false)
    const handlerExit = (e) =>{
        e.preventDefault();
        localStorage.removeItem("dToken");
        localStorage.removeItem("page");
        localStorage.removeItem("expiret_at");
        window.location.href = `/project/matrix/${id}`;
    }
    const [isAddNew, setIsAddNew] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [toEdit, setToEdit] = useState(null)
    const [isDelete, setIsDelete] = useState(false)
    const [toDelete, setToDelete] = useState(null)
    return (
        <div className={`matrix-container ${tableFull ? "full-page" : "normal"}`}>
            <Helm id={"36"} />

            <div className="closer">
                <div className="close-info">
                    <p>Click ESC or &#x2715; button to close full-page table</p>
                </div>

                <button onClick={() => setTableFull(false)} className="close-btn ">
                    &#x2715;
                </button>
            </div>
            <div className="full">
                <button onClick={() => setTableFull(true)} className="close-btn">
                    Click to see full table
                </button>
                {
                    token?<button className="user-btn" onClick={handlerExit} title="Click to exit edit mode.">
                        <img src={lock_open_icon} alt="Log in"/>
                    </button>:<button className="user-btn" onClick={handlePopupToggle} title="Click to pass authentication, which allows you to enable edit mode.">
                        <img src={lock_closed_icon} alt="Log out"/>
                    </button>
                }


            </div>
            <AuthPopup isOpen={isPopupOpen} onClose={handlePopupToggle} id={id}/>
            <div className="matrix-filter menu-container">
                {donors.isFetched ? (
                    donors.data?.map((el, inx) => (
                        <Link to={`/project/matrix/${el.id}`} key={inx} title={el.full_name}>
                            <button className={`menu-item ${id === el.id ? "active" : ""}`} style={{position:"relative"}}>
                                {el.short_name}
                                {
                                    token && page === el.id ?
                                        <img className="menu-lock-icon" src={lock_open_green_icon} alt=""/>
                                        : null
                                }
                            </button>
                        </Link>
                    ))
                ) : (
                    <h5>Loading ...</h5>
                )}
            </div>

            <div className="matrix-table">
                <table>
                        <colgroup>
                            <col style={{ width: "2%" }} />
                            <col style={{ width: "15%" }} />
                            <col style={{ width: "10%" }} />
                        </colgroup>
                    <thead>
                    <tr>
                        <th>No</th>
                        <th>Project Title and Description</th>
                        <th>Ongoing Activities</th>
                        <th>Project Region</th>
                        <th>Project Cities, Districts</th>
                        <th>Physical Objective</th>
                        <th>Implementation Period</th>
                        <th>Grant/ Loan agreement date</th>
                        <th>Total Project Cost</th>
                        <th>Grant/Loan Amount</th>
                        <th>Expected Completion Date</th>
                        <th>Government Commitment</th>
                        <th>Project Website</th>
                        <th>Contact Person</th>
                        <th>Implementation Status</th>
                    </tr>
                    </thead>

                    <tbody className="title">
                    <tr>
                        <td></td>
                        <td colSpan={tableFull?14:4} style={{color: "#1097ef"}}>
                            <div className="block-title">
                                <span>WATER SUPPLY AND SANITATION</span>
                                    {
                                        token && page === id ?
                                            <div className="action-button">
                                                <button className="add-button" onClick={() => setIsAddNew(1)}>
                                                    <span className="action-icon">+</span>
                                                    <span className="action-tooltip">
                                                        <span className="tooltip-text">Add new to water supply and sanitation</span>
                                                    </span>
                                                </button>

                                            </div>
                                            : null
                                    }
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tbody className="body">
                    {donorProjects.map((m, index) => {
                        if (m.directions.trim() === "WATER SUPPLY AND SANITATION") {
                            tpc1 += parseFloat(fixtonumber(m.project_cost));
                            gla1 += parseFloat(fixtonumber(m.grant_loan_amount));
                            gc1 += parseFloat(fixtonumber(m.govern_commitment));

                            return (
                                <tr key={index}>
                                    <td>{m.number}</td>
                                    <td title={m.project_title}>
                                        <div className="td-text">
                                            {m.project_title}
                                        </div>
                                    </td>
                                    <td title={m.ongoing_activities || "-"}>
                                        <div className="td-text">
                                            {m.ongoing_activities || "-"}
                                        </div>
                                    </td>
                                    <td>{m.project_region}</td>
                                    <td>{m.project_districts}</td>
                                    <td title={m.physical_objective}>
                                        <div className="td-text">
                                            {m.physical_objective}
                                        </div>
                                    </td>
                                    <td>{m.impl_period_from} - {m.impl_period_to}</td>
                                    <td>{m.grant_agrement_date}</td>
                                    <td>{m.project_cost}</td>
                                    <td>{m.grant_loan_amount}</td>
                                    <td>{m.compl_date || "-"}</td>
                                    <td>{m.govern_commitment}</td>
                                    <td>{m.project_website || "-"}</td>
                                    <td>{m.contact_person || "-"}</td>
                                    <td style={{position:"relative"}}>
                                        <div>
                                            <span>{m.impl_status}</span>
                                            {
                                                token && id === page?
                                                    <div className="subject-actions">
                                                        <div className="action-button">
                                                            <button className="edit-button" onClick={() => {
                                                                setIsEdit(true);
                                                                setToEdit(m);
                                                            }}>
                                                                <span className="action-icon">&#9998;</span>
                                                                <span className="action-tooltip">
                                                                    <span className="tooltip-text">Edit "{m.project_title}"</span>
                                                                </span>
                                                            </button>
                                                        </div>
                                                        <div className="action-button">
                                                            <button className="remove-button" onClick={() => {
                                                                setIsDelete(true);
                                                                setToDelete(m)
                                                            }}>
                                                                <span className="action-icon">&#128465;</span>
                                                                <span className="action-tooltip">
                                                                    <span className="tooltip-text">
                                                                        Remove "{m.project_title}"
                                                                    </span>
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                    </td>
                                </tr>
                            );
                        }
                        return null;
                    })}
                    </tbody>
                    <tbody className="subtotal">
                    <tr>
                        <td></td>
                        <td colSpan={tableFull?7:2} style={{textAlign:"end"}}>{`SUBTOTAL '${donor?.full_name || ''}'`}</td>
                        <td>{fixtorender(tpc1)}</td>
                        <td>{fixtorender(gla1)}</td>
                        <td></td>
                        <td>{fixtorender(gc1)}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    </tbody>
                    <tbody className="title">
                    <tr>
                        <td></td>
                        <td colSpan={tableFull?14:4} style={{color: "#1097ef"}}>
                            <div className="block-title">
                                <span>WATER RESOURCES MANAGEMENT</span>
                                {
                                    token && page === id ?
                                        <div className="action-button">
                                            <button className="add-button" onClick={() => setIsAddNew(2)}>
                                                <span className="action-icon">+</span>
                                                <span className="action-tooltip">
                                                    <span className="tooltip-text">Add new to water resources management</span>
                                                </span>
                                            </button>
                                        </div>
                                        : null
                                }
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tbody className="body">
                    {donorProjects.map((m, index) => {
                        if (m.directions.trim() === "WATER RESOURCES MANAGEMENT") {
                            tpc2 += parseFloat(fixtonumber(m.project_cost));
                            gla2 += parseFloat(fixtonumber(m.grant_loan_amount));
                            gc2 += parseFloat(fixtonumber(m.govern_commitment));
                            return (
                                <tr key={index}>
                                    <td>{m.number}</td>
                                    <td title={m.project_title}>
                                        <div className="td-text">
                                            {m.project_title}
                                        </div>
                                    </td>
                                    <td title={m.ongoing_activities || "-"}>
                                        <div className="td-text">
                                            {m.ongoing_activities || "-"}
                                        </div>
                                    </td>
                                    <td>{m.project_region}</td>
                                    <td>{m.project_districts}</td>
                                    <td title={m.physical_objective}>
                                        <div className="td-text">
                                            {m.physical_objective}
                                        </div>
                                    </td>
                                    <td>{m.impl_period_from} - {m.impl_period_to}</td>
                                    <td>{m.grant_agrement_date}</td>
                                    <td>{m.project_cost}</td>
                                    <td>{m.grant_loan_amount}</td>
                                    <td>{m.compl_date || "-"}</td>
                                    <td>{m.govern_commitment}</td>
                                    <td>{m.project_website || "-"}</td>
                                    <td>{m.contact_person || "-"}</td>
                                    <td style={{position:"relative"}}>
                                        <div>
                                            <span>{m.impl_status}</span>
                                            {
                                                token && id === page?
                                                    <div className="subject-actions">
                                                        <div className="action-button">
                                                            <button className="edit-button" onClick={() => {
                                                                setIsEdit(true);
                                                                setToEdit(m);
                                                            }}>
                                                                <span className="action-icon">&#9998;</span>
                                                                <span className="action-tooltip">
                                                                    <span className="tooltip-text">Edit "{m.project_title}"</span>
                                                                </span>
                                                            </button>
                                                        </div>
                                                        <div className="action-button">
                                                            <button className="remove-button" onClick={() => {
                                                                setIsDelete(true);
                                                                setToDelete(m)
                                                            }}>
                                                                <span className="action-icon">&#128465;</span>
                                                                <span className="action-tooltip">
                                                                    <span className="tooltip-text">
                                                                        Remove "{m.project_title}"
                                                                    </span>
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                    </td>
                                </tr>
                            );
                        }
                        return null;
                    })}
                    </tbody>

                    <tfoot className="subtotal">
                    <tr>
                        <td></td>
                        <td colSpan={tableFull?7:2} style={{textAlign:"end"}}>{`SUBTOTAL '${donor?.full_name || ''}'`}</td>
                        <td>{fixtorender(tpc2)}</td>
                        <td>{fixtorender(gla2)}</td>
                        <td></td>
                        <td>{fixtorender(gc2)}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td colSpan={tableFull?7:2} style={{textAlign:"end"}}>{`TOTAL '${donor?.full_name || ''}'`}</td>
                        <td>{parseFloat(fixtonumber(tpc1)) + parseFloat(fixtonumber(tpc2))}</td>
                        <td>{parseFloat(fixtonumber(gla1)) + parseFloat(fixtonumber(gla2))}</td>
                        <td></td>
                        <td>{parseFloat(fixtonumber(gc1)) + parseFloat(fixtonumber(gc2))}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    </tfoot>
                </table>
                {
                    isAddNew && <AddProjectPopup
                        onClose={() => setIsAddNew(false)}
                        isAddNew = {isAddNew}
                        fetchMatrix = {fetchMatrix}
                    />
                }
                {
                    isEdit && <EditProjectPopup
                        onClose={() => setIsEdit(false)}
                        fetchMatrix = {fetchMatrix}
                        toEdit = {toEdit}
                        setToEdit = {setToEdit}
                    />
                }
                {
                    isDelete && <DeleteProjectPopup
                        onClose={() => setIsDelete(false)}
                        fetchMatrix = {fetchMatrix}
                        toDelete = {toDelete}
                    />
                }
            </div>
        </div>
    );
};

export default SingleMatrix;
function fixtorender(data){
    if (data !== undefined && data !== null && data !== ''){
        if(data == 0) return 0
        return parseFloat(data).toFixed(2)
    }else return '-';
}
function fixtonumber(data) {
    if (data !== undefined && data !== null && data !== '') {
        if (data == 0) return 0;

        try {
            // Faqat string bo'lsa, replace() ishlaydi
            if (typeof data === "string") {
                data = data.replace(",", ".");
            }
            let num = parseFloat(data);
            return isNaN(num) ? 0 : num.toFixed(2);
        } catch (e) {
            console.log("ex", e, "|", data, "|");
        }
    }
    return 0;
}
